import * as React from 'react';
import styled from 'styled-components';
import { IBSwitchButtonProps } from './SwitchButton.types';
import { handleOnClick } from './SwitchButton.logic';
import { NoneButton } from '../AttachmentTag/AttachmentTag';

const StyledSwitchButton = styled(NoneButton)<{ active: boolean }>`
  height: 17.13px;
  width: 31.92px;
  background-color: ${({ theme, active }) =>
    active ? theme.colors.primary : theme.colors.gray};
  border-radius: 8.565px;

  .switch-toggle {
    width: 12.46px;
    height: 12.46px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.white};
  }

  .switch-toggle.active {
    margin-left: 11.35px;
    -webkit-transition: margin-left 0.2s ease-out;
    -moz-transition: margin-left 0.2s ease-out;
    -o-transition: margin-left 0.2s ease-out;
    transition: margin-left 0.2s ease-out;
  }

  .switch-toggle.inactive {
    margin-left: -3.11px;
    -webkit-transition: margin-left 0.2s ease-out;
    -moz-transition: margin-left 0.2s ease-out;
    -o-transition: margin-left 0.2s ease-out;
    transition: margin-left 0.2s ease-out;
  }
`;

const SwitchButton: React.FC<IBSwitchButtonProps> = (
  props: IBSwitchButtonProps
) => {
  const { className, isActive, onClick, testId } = props;
  return (
    <div className={className}>
      <StyledSwitchButton
        active={isActive}
        className={`${isActive ? 'active' : 'inactive'} switch-button`}
        data-testid={testId || 'switch-button'}
        type="button"
        onClick={() => handleOnClick(onClick)}
      >
        <div className={`switch-toggle ${isActive ? 'active' : 'inactive'}`} />
      </StyledSwitchButton>
    </div>
  );
};

export default SwitchButton;
